/**
 * TypeScript port of requestVideoFrameCallback polyfill from
 * https://github.com/ThaUnknown/rvfc-polyfill
 */

type HTMLVideoElementPolyfill = {
  videoWidth: number;
  videoHeight: number;
  currentTime: number;
  _rvfcpolyfillmap: Record<number, number>;
  mozFrameDelay?: number;
  cancelVideoFrameCallback(handle: number): void;
  requestVideoFrameCallback(
    this: HTMLVideoElementPolyfill,
    callback: VideoFrameRequestCallback,
  ): number;
  getVideoPlaybackQuality(): VideoPlaybackQuality & {
    totalFrameDelay: number;
  };
};

if (
  typeof HTMLVideoElement !== 'undefined' &&
  !('requestVideoFrameCallback' in HTMLVideoElement.prototype) &&
  'getVideoPlaybackQuality' in HTMLVideoElement.prototype
) {
  const videoElementProto: HTMLVideoElementPolyfill =
    HTMLVideoElement.prototype;
  videoElementProto._rvfcpolyfillmap = {};
  videoElementProto.requestVideoFrameCallback = function (
    callback: VideoFrameRequestCallback,
  ) {
    const handle = performance.now();
    const quality = this.getVideoPlaybackQuality();
    const baseline = quality.totalVideoFrames - quality.droppedVideoFrames;

    const check = (now: number) => {
      const newQuality = this.getVideoPlaybackQuality();
      const presentedFrames =
        newQuality.totalVideoFrames - newQuality.droppedVideoFrames;
      if (presentedFrames > baseline) {
        const processingDuration =
          this.mozFrameDelay ||
          newQuality.totalFrameDelay - quality.totalFrameDelay ||
          0;
        callback(now, {
          presentationTime: now - processingDuration * 1000,
          expectedDisplayTime: now,
          width: this.videoWidth,
          height: this.videoHeight,
          mediaTime: this.currentTime,
          presentedFrames,
          processingDuration,
        });
        delete this._rvfcpolyfillmap[handle];
      } else {
        this._rvfcpolyfillmap[handle] = requestAnimationFrame((newer) => {
          check(newer);
        });
      }
    };
    this._rvfcpolyfillmap[handle] = requestAnimationFrame((newer) => {
      check(newer);
    });
    return handle;
  };

  videoElementProto.cancelVideoFrameCallback = function (handle: number) {
    cancelAnimationFrame(this._rvfcpolyfillmap[handle]);
    delete this._rvfcpolyfillmap[handle];
  };
}
